/* eslint-disable react/prop-types */
import React from 'react';
import {useSelector} from 'react-redux';

import {AddedTaskSection} from './components';

export const AddedTask = ({
  isPublished,
  removeTask,
  control,
  getValues,
  setValue,
  register,
  isArchive,
  clearErrors,
  setError,
  setOpenAddTask,
}) => {
  const assessmentState = useSelector(state => state.assessment);
  const {createdTasks, assessmentTasksLoading} = assessmentState;

  return (
    <>
      <AddedTaskSection
        createdTasks={createdTasks}
        isLoadingAssessment={assessmentTasksLoading}
        isPublished={isPublished}
        removeTask={removeTask}
        control={control}
        getValues={getValues}
        setValue={setValue}
        register={register}
        isArchive={isArchive}
        clearErrors={clearErrors}
        setError={setError}
        setOpenAddTask={setOpenAddTask}
      />
    </>
  );
};
